export const styles = (theme) => ({
    bottomMargin: {
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 700,
    },
    cellHead: {
        "& th": {
            fontWeight: 600,
        },
        backgroundColor: "#F0F0F0"
    },
});